"use client"

import { useEffect, useRef } from "react"
import { useTracking } from "@lib/analytics/tracking-context"
import type { GtmItem } from "@lib/analytics/gtm"

/**
 * Fires `view_item_list` once when a product grid mounts. Items are built on the
 * server and passed in as plain objects (serializable).
 */
export default function ListViewTracker({
  listId,
  listName,
  items,
}: {
  listId: string
  listName: string
  items: GtmItem[]
}) {
  const { trackViewItemList } = useTracking()
  const fired = useRef(false)

  useEffect(() => {
    if (fired.current) return
    if (!items.length) return
    fired.current = true
    trackViewItemList(listId, listName, items)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [listId])

  return null
}
